// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.style-font-size[data-v-aeba673c] {\n  font-size: 14px;\n}\n.style-branch-container[data-v-aeba673c] {\n  font-size: 16px;\n  border: 1px solid #adadad;\n  cursor: pointer;\n  height: 50px;\n  background-color: white;\n}\n.style-branch-content[data-v-aeba673c] {\n  font-size: 16px;\n  padding-top: 3px;\n  padding-right: 10px;\n}\n.style-option-height[data-v-aeba673c] {\n  min-height: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
